<template>
    <div
        component="Shortlist"
        :class="{
            'small-design': this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs,
            'xs-design': this.$vuetify.breakpoint.xs,
        }"
    >
        <v-row class="column-wrapper">
            <character-detail />

            <v-col sm="12" md="8" class="right-column">
                <v-row>
                    <v-col class="middle">
                        <shortlist-character />
                    </v-col>

                    <v-col class="right">
                        <voices />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import ShortlistCharacter from '@/components/Project/Shortlist/ShortlistCharacter.vue';
import Voices from '@/components/Project/Voices/Voices.vue';
import CharacterDetail from '@/components/Project/Character/CharacterDetail.vue';

export default {
    name: 'Shortlist',

    components: {
        ShortlistCharacter,
        Voices,
        CharacterDetail,
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='Shortlist'] {
    height: inherit;

    .column-wrapper {
        margin: 0;
        height: 100%;

        & > .col {
            padding: 8px !important;
        }

        .v-card {
            display: flex;
            flex-direction: column;

            .v-card__title {
                padding: 0px 16px;
                font-size: 1rem;
                font-weight: bold;
            }
        }
    }

    .right-column {
        height: 100%;
        position: relative;
        padding: 0;

        .row {
            height: 100%;
            margin: 0;

            .col {
                width: 50%;
                &.middle {
                    padding: 0 8px 0 0;
                }

                &.right {
                    padding: 0 0 0 8px;
                }
            }

            .v-card {
                min-height: 100%;
            }
        }
    }
}

[component='Shortlist'] {
    &.small-design {
        position: relative;
    }
}
</style>
